<desy-collapsible
  [open]="open"
  *ngIf="type !== '1'">
  <div class="text-[18px] font-bold">{{ title }}</div>
  <desy-content>
    <div *ngIf="items">
      <div class="grid grid-cols-3 grid-flow-row-dense gap-2 mt-2">
        <ul *ngFor="let item of items | appSorting; let index = index">
          <li class="text-[16px] font-regular mt-2">{{ item }}</li>
        </ul>
      </div>
    </div>
    <div class="flex flex-col items-start mt-4">
      <div *ngIf="description">
        <span class="text-sm text-neutral-dark">{{ description }}</span>
      </div>
      <a
        *ngIf="url"
        class="text-sm text-primary-base underline"
        [href]="normalizeUrl(url)"
        target="_blank"
        rel="noopener noreferrer">
        Ir a detalles
      </a>
    </div>
    @if (itemsTableHeader) {
      <div>
        <app-tables
          [itemsTableHeader]="itemsTableHeader"
          [itemsTableRows]="itemsTableRows" />
      </div>
    }
  </desy-content>
</desy-collapsible>
<desy-collapsible *ngIf="type === '1'">
  <div class="text-[18px] font-bold">{{ title }}</div>
  <desy-content>
    <!-- Tipo, Rango y Fecha en fila -->
    <div class="flex flex-col gap-4 mt-4">
      <div class="flex gap-2">
        <span class="font-bold">Titulo de la normativa:</span>
        <span>{{ regulation?.regulationsTitle }}</span>
      </div>
      <div class="flex gap-6">
        <div class="flex gap-2">
          <span class="font-bold">Rango:</span>
          <span>{{ regulation?.range }}</span>
        </div>

        <div class="flex gap-2">
          <span class="font-bold">Fecha:</span>
          <span>{{ regulation?.date ? ($any(regulation?.date) | spanishDate) : '' }}</span>
        </div>
        <div class="flex gap-2">
          <span class="font-bold">Tipo:</span>
          <span>{{ regulation?.type }}</span>
        </div>
      </div>
      <div class="flex gap-6">
        <div class="flex gap-2">
          <span class="font-bold">Enlace de la normativa:</span>
          <a
            class="underline text-primary-base"
            href="{{ regulation?.regulationsUrl }}">
            {{ regulation?.regulationsUrl }}
          </a>
        </div>
        <div class="flex gap-2">
          <span class="font-bold">Fecha de vigencia:</span>
          <span>{{ regulation?.limitTime ? ($any(regulation?.limitTime) | spanishDate) : '' }}</span>
        </div>
      </div>
    </div>
  </desy-content>
</desy-collapsible>
